"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeHtml = void 0;
const dompurify_1 = __importDefault(require("dompurify"));
dompurify_1.default.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});
const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'br', 'a', 'p', 'span'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];
const sanitizeHtml = (html) => dompurify_1.default.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR }).trim();
exports.sanitizeHtml = sanitizeHtml;
